import { render } from "./GoogleSymbols.vue?vue&type=template&id=0a21388e"
import script from "./GoogleSymbols.vue?vue&type=script&lang=js"
export * from "./GoogleSymbols.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__